// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tickets-module--wrapper--3ivZD","lead":"tickets-module--lead--220ik","signUp":"tickets-module--signUp--3nbXd","section":"tickets-module--section--1PfEy"};